import { addParamsToQueryString } from '../functions/utils';
import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';
import axios from 'axios';
import { PaymentToken } from 'redhotpie-shared-lib/types/payment';

export interface IPaymentGatewayPurchaseParams {
  token: string;
  purchaseToken?: string;
  number?: string;
  diamond?: boolean;
}

class PaymentGatewayApi {
  static getPaymentGateway(): Promise<IApiResponse<any>> {
    return axios.get(urls.UPGRADE_MEMBERSHIP, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static paymentGatewayPurchase(params: IPaymentGatewayPurchaseParams): Promise<IApiResponse<any>> {
    const url = urls.UPGRADE_PURCHASE;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static googlePurchase(body: { Token: PaymentToken; Product: { Token: string }; PurchaseToken: string }): Promise<IApiResponse<any>> {
    const url = urls.UPGRADE_PURCHASE;
    return axios.post(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getActivePurchase(): Promise<IApiResponse<any>> {
    return axios.get(urls.GET_ACTIVE_MEMBERSHIP, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getCreditsPurchase(): Promise<IApiResponse<any>> {
    return axios.get(urls.GET_CREDIT_MEMBERSHIP, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getInfoProduct(params: any): Promise<IApiResponse<any>> {
    const url = addParamsToQueryString(urls.GET_INFO_PRODUCT, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default PaymentGatewayApi;
